<style lang="scss" scoped>
@import "./management.modal.scss";

.logs-container {
    margin-top: 20px;
}

.logs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.logs-title {
    font-size: 1.5em;
    font-weight: 500;
    color: #505050;
}

.log-detail-row {
    margin-bottom: 10px;
}

.log-detail-label {
    font-weight: 600;
    color: #505050;
    margin-bottom: 5px;
}

.log-detail-content {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.9em;
    max-height: 200px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-all;
}

.status-success {
    color: #4caf50;
    font-weight: 600;
}

.status-error {
    color: #f44336;
    font-weight: 600;
}

.status-pending {
    color: #ff9800;
    font-weight: 600;
}

.expandable-row {
    cursor: pointer;
}

.expand-icon {
    font-size: 1.2em;
    vertical-align: middle;
    margin-left: 5px;
}
</style>

<template>
    <div class="logs-container">
        <table class="table">
            <thead>
                <tr>
                    <th style="width: 10%">ID</th>
                    <th style="width: 15%">Status</th>
                    <th style="width: 15%">Recurso</th>
                    <th style="width: 15%">Referência</th>
                    <th style="width: 15%">Tempo (ms)</th>
                    <th style="width: 20%">Executado em</th>
                    <th style="width: 10%">Ações</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="logs.length === 0">
                    <tr>
                        <td colspan="7" class="empty-state">Nenhum log encontrado</td>
                    </tr>
                </template>

                <template v-for="(log, idx) in logs">
                    <tr :class="[{ 'page-table-line-special': idx % 2 !== 0 }]" :key="log.id">
                        <td>#{{ log.id }}</td>
                        <td>
                            <span
                                :class="{
                                    'status-success': log.status === 'success',
                                    'status-error': log.status === 'error',
                                    'status-pending': log.status === 'pending',
                                }"
                            >
                                {{ log.status }}
                            </span>
                        </td>
                        <td>
                            {{ log.related_resource_type || "-" }}
                            <span v-if="log.related_resource_id">#{{ log.related_resource_id }}</span>
                        </td>
                        <td>{{ log.external_reference || "-" }}</td>
                        <td>{{ log.execution_time_ms || "-" }}</td>
                        <td>{{ formatDate(log.executed_at) }}</td>
                        <td>
                            <span class="material-icons-outlined edit-icon expandable-row" title="Ver detalhes" @click="toggleDetails(log)">
                                {{ expandedLogs[log.id] ? "expand_less" : "expand_more" }}
                            </span>
                        </td>
                    </tr>

                    <tr v-if="expandedLogs[log.id]" :class="[{ 'page-table-line-special': idx % 2 !== 0 }]" :key="'exp-' + log.id">
                        <td colspan="7" style="padding: 20px;">
                            <div class="log-detail-row" v-if="log.request_data">
                                <div class="log-detail-label">Request Data:</div>
                                <div class="log-detail-content">{{ formatJson(log.request_data) }}</div>
                            </div>

                            <div class="log-detail-row" v-if="log.response_data">
                                <div class="log-detail-label">Response Data:</div>
                                <div class="log-detail-content">{{ formatJson(log.response_data) }}</div>
                            </div>

                            <div class="log-detail-row" v-if="log.error_message">
                                <div class="log-detail-label">Error Message:</div>
                                <div class="log-detail-content status-error">{{ log.error_message }}</div>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

        <div v-if="pagination.total > pagination.per_page" style="margin-top: 20px;">
            <cc-pagination
                classes="orange"
                :items_by_page_value="pagination.per_page"
                :total="pagination.total"
                :page="pagination.current_page"
                :page_limit="9"
                @change="$emit('page-change', $event)"
            />
        </div>
    </div>
</template>

<script>
import Button from "@/components/ui/buttons/StandardButton.vue";
import Pagination from "@/components/cliente/base-components/Pagination";

export default {
    name: "IntegrationLogsComponent",
    components: {
        Button,
        ccPagination: Pagination,
    },
    props: {
        integration: {
            type: Object,
            required: true,
        },
        logs: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => ({
                current_page: 1,
                per_page: 20,
                total: 0,
            }),
        },
    },
    data() {
        return {
            expandedLogs: {},
        };
    },
    methods: {
        toggleDetails(log) {
            this.$set(this.expandedLogs, log.id, !this.expandedLogs[log.id]);
        },
        formatJson(data) {
            if (typeof data === "string") {
                try {
                    return JSON.stringify(JSON.parse(data), null, 2);
                } catch (e) {
                    return data;
                }
            }
            return JSON.stringify(data, null, 2);
        },
        formatDate(dateString) {
            if (!dateString) return "-";
            try {
                const date = new Date(dateString);
                return date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                });
            } catch (e) {
                return dateString;
            }
        },
    },
};
</script>
